module.exports = __webpack_public_path__ + "static/media/shutterstock-599939000-copy-3.4917e168.png";